import { useContext } from "react";
import { Setting } from "../../../context/settings";
import { consumeInventory } from "./utilites/techniques/consumeInventory";
import { validationStock } from "./utilites/techniques/validationTotalStock";
import { auth } from "../../../context/auth";
import { toast } from "react-toastify";
import { clearInventorySession } from "./utilites/techniques/inventorySession";

export default function useTechniqueOffset() {
    const { storeBusniessRules } = useContext(Setting);
    const { ActivEmp } = useContext(auth);

    const offsetBatch = async (cart, invoiceId) => {
        const inventoryMethod = storeBusniessRules?.techniqueOffset;

        if (!cart?.length || !ActivEmp || !inventoryMethod || !invoiceId) {
            return [];
        }

        /*
        ===================================
        Step 1 : Validate all products
        ===================================
        */
        try {
            const validated = [];
    
            for (const item of cart) {
    
                if (!item.inventory?.length) {
                    validated.push({
                        ...item,
                        stock: null
                    });
    
                    continue;
                }
                const meta = {
                    method: inventoryMethod,
                    measure: item.measure
                }
                const validation = await validationStock(
                    item.prod_id,
                    item.quantity,
                    meta
                );
    
                if (!validation.success) {
                    toast.error(validation.message);
    
                    return [];
                }
    
                validated.push({
                    ...item,
                    stock: validation.data
                });
            }
    
            
            /*
            ===================================
            Step 2 : Consume inventory
            ===================================
            */
            const updatedCart = [];
            
            for (const item of validated) {
    
                if (!item.stock) {
                    
                    const { stock, ...product } = item;
                    
                    updatedCart.push({
                        ...product,
                        offset_batch: null
                    });
                    
                    continue;
                }
                
                const meta = {
                    taker: ActivEmp.name,
                    measure: item.stock.measure,
                    invoiceId
                };
                
                
                const consumeResult = await consumeInventory(
                    item.stock.affectedBatches,
                    meta
                );
    
                if (!consumeResult.success) {
                    toast.error(consumeResult.message);
    
                    return [];
                }
    
                const { stock, ...product } = item;
    
                updatedCart.push({
                    ...product,
                    offset_batch: consumeResult.data
                });
            }

            return updatedCart;
        }
        catch(err) {
            console.log("error => ", err);
        }
        finally {
            clearInventorySession();
        }

    };

    return {
        offsetBatch
    };
}